import './../../core/style/HeroDisplay.css';

const HeroDisplay = () => {
  const scrollToCatalog = () => {
    const element = document.getElementById('catalog');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.error("Target ID 'catalog' not found in the DOM.");
    }
  };

  return (
    <header className="hero-container">
      {/* <video
        autoPlay
        muted
        loop
        playsInline
        className="hero-video"
        poster="/images/Poster.png"
      >
        <source src="/videos/busan-hero-industrial.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video> */}
      <picture>
        <source media="(max-width: 768px)" srcSet="/images/mobilePoster.jpg" />
        <img 
          src="/images/HBM1400.jpg" 
          className="hero-video" 
          alt="High-performance Busan hydraulic rock breaker mounted on a JCB excavator at a construction site" 
        />
      </picture>

      <div className="hero-overlay"></div>

      <div className="hero-content">
        <h1 className="hero-title">
          <span className="hero-subtitle">Busan Hydraulic Rock Breaker</span>
          Precision Power <br /> Maximum Impact
        </h1>
        <p className="hero-description">
          Delivering precision-engineered excavator hydraulic rock breakers, JCB breakers, and hydraulic quick couplers for heavy-duty machinery.
        </p>
        <div className="hero-actions">
          <button
            className="btn-primary"
            onClick={scrollToCatalog}
          >
            View Technical Catalog
          </button>
        </div>
      </div>
    </header>
  );
};

export default HeroDisplay;